import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/monitoring/preeclampsia-warning-signs/#webpage",
   "url": "https://www.futurefamilyai.com/monitoring/preeclampsia-warning-signs/",
   "name": "Preeclampsia Warning Signs to Know | FutureFamilyAI",
   "description": "Severe headache, vision changes, upper belly pain, breathing trouble, sudden swelling: know the preeclampsia warning signs and when to get help.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Blood Pressure During Pregnancy",
     "item": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Preeclampsia Warning Signs",
     "item": "https://www.futurefamilyai.com/monitoring/preeclampsia-warning-signs/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What are the first signs of preeclampsia?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "High blood pressure is often the first sign, sometimes with headache, swelling or vision changes."
     }
    },
    {
     "@type": "Question",
     "name": "When should I go to the hospital for preeclampsia symptoms?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Seek immediate care for severe headache, vision changes, chest pain, trouble breathing, upper abdominal pain or a reading in the severe range."
     }
    },
    {
     "@type": "Question",
     "name": "Can you have preeclampsia without symptoms?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. That is why routine blood pressure checks matter."
     }
    },
    {
     "@type": "Question",
     "name": "When does preeclampsia usually start?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most often after 20 weeks of pregnancy, and it can occur up to about six weeks after delivery."
     }
    },
    {
     "@type": "Question",
     "name": "Can an app detect preeclampsia?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No app can diagnose preeclampsia. FutureFamilyAI helps organize readings and symptoms so you and your care team notice patterns sooner."
     }
    },
    {
     "@type": "Question",
     "name": "Is swelling in pregnancy a sign of preeclampsia?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Mild swelling is common. Sudden swelling of the face or hands, especially with other symptoms, should be checked promptly."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function MonitoringPreeclampsiaWarningSignsPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/monitoring/blood-pressure-pregnancy">
                Blood Pressure During Pregnancy
              </Link>
              <span>›</span>
              <span>Preeclampsia Warning Signs</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Preeclampsia warning signs include a severe headache that
                won&apos;t go away, vision changes, pain under the ribs on the
                right side, shortness of breath, and sudden swelling of the face
                or hands, usually with high blood pressure after 20 weeks.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S.
                      delivery hospitalizations (2017–2019). (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Symptom checklist built into every reading · Red status
                      says &apos;contact your provider now&apos; · Monitoring
                      continues postpartum
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">BLOOD PRESSURE GUIDE</span>
            <h1>Preeclampsia Warning Signs You Should Never Ignore</h1>
            <p className="ffh-answer speakable-content">
              Preeclampsia warning signs include a severe headache that
              won&apos;t go away, vision changes, pain under the ribs on the
              right side, shortness of breath, and sudden swelling of the face
              or hands, usually with high blood pressure after 20 weeks. These
              need prompt medical attention. FutureFamilyAI logs symptoms with
              every cuff reading, but never wait for an app — call your provider
              or 911.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Pregnant woman calling her provider about possible preeclampsia warning signs"
              >
                <figcaption>
                  <b>Photo slot</b> · Calm, editorial photo: pregnant woman on
                  the phone with her doctor, one hand on her belly, serious but
                  composed. No distress imagery, no text.
                  <br />
                  <b>Alt:</b> Pregnant woman calling her provider about possible
                  preeclampsia warning signs
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                  <li>
                    In pregnancy, a blood pressure of 160 systolic or 110
                    diastolic or higher is in the severe range and needs urgent
                    evaluation.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/practice-bulletin/articles/2020/06/gestational-hypertension-and-preeclampsia">
                        ACOG Practice Bulletin No. 222, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    Postpartum preeclampsia can develop up to about six weeks
                    after delivery, most often within the first days.
                    <cite>
                      Source:{" "}
                      <a href="https://www.preeclampsia.org/postpartum">
                        Preeclampsia Foundation
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Warning signs</h2>
                <ul>
                  <li>Severe or persistent headache</li>
                  <li>Blurred vision, spots or light sensitivity</li>
                  <li>Upper abdominal or right-side pain</li>
                  <li>Nausea or vomiting in the second half of pregnancy</li>
                  <li>Shortness of breath</li>
                  <li>Sudden swelling of face or hands</li>
                </ul>
              </section>
              <section id="s2">
                <h2>What to do</h2>
                <p>
                  Call your obstetric provider immediately, or 911 for severe
                  symptoms. Bring or share your recent readings if you can.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>Preeclampsia can happen after birth</h2>
                <p>
                  Postpartum preeclampsia can occur days to weeks after
                  delivery. Keep monitoring as advised.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>What are the first signs of preeclampsia?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        High blood pressure is often the first sign, sometimes
                        with headache, swelling or vision changes.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      When should I go to the hospital for preeclampsia
                      symptoms?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Seek immediate care for severe headache, vision changes,
                        chest pain, trouble breathing, upper abdominal pain or a
                        reading in the severe range.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can you have preeclampsia without symptoms?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. That is why routine blood pressure checks matter.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>When does preeclampsia usually start?</summary>
                    <div className="ffh-ans">
                      <p>
                        Most often after 20 weeks of pregnancy, and it can occur
                        up to about six weeks after delivery.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can an app detect preeclampsia?</summary>
                    <div className="ffh-ans">
                      <p>
                        No app can diagnose preeclampsia. FutureFamilyAI helps
                        organize readings and symptoms so you and your care team
                        notice patterns sooner.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is swelling in pregnancy a sign of preeclampsia?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Mild swelling is common. Sudden swelling of the face or
                        hands, especially with other symptoms, should be checked
                        promptly.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/monitoring/blood-pressure-pregnancy">
                    Blood Pressure During Pregnancy →
                  </Link>
                  <Link to="/monitoring/gestational-hypertension-symptoms">
                    Gestational Hypertension Symptoms →
                  </Link>
                  <Link to="/monitoring/home-blood-pressure-cuff-pregnancy">
                    Home Blood Pressure Cuffs →
                  </Link>
                  <Link to="/monitoring/blood-pressure-chart-pregnancy-trimester">
                    Blood Pressure Chart by Trimester →
                  </Link>
                  <Link to="/monitoring/when-to-call-doctor-blood-pressure-pregnancy">
                    When to Call Your Doctor About BP →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Warning signs</a>
                  </li>
                  <li>
                    <a href="#s2">What to do</a>
                  </li>
                  <li>
                    <a href="#s3">Preeclampsia can happen after birth</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
